import { format } from 'date-fns';
import { useGetRequest } from 'hooks/utils/useGetRequest';
import { ExporterFiles } from 'interfaces/exporter';

export type UseGetExporterFilesResult = {
  files: { id: string }[];
  isLoading: boolean;
  isError: any;
};

function getPreviousMonth(date = new Date()) {
  const previous = new Date(date.getTime());
  previous.setMonth(date.getMonth() - 1);

  return previous;
}

const useGetExporterFiles = (
  processType: string,
  name?: string,
  startDate?: string,
  endDate?: string
): UseGetExporterFilesResult => {
  const defaultStartDate = `${format(getPreviousMonth(), 'yyyy-MM-dd')}T00:00:00`;
  const defaultEndDate = `${format(new Date(), 'yyyy-MM-dd')}T23:59:00`;

  let basePath = `v1/exporter?process=${processType || 'CLEARING'}&startDate=${startDate || defaultStartDate}&endDate=${
    endDate || defaultEndDate
  }`;
  if (name) {
    basePath += `&name=${name}`;
  }

  const [{ data, error, loading }] = useGetRequest<ExporterFiles>({
    path: basePath,
  });

  return {
    files: data?.files?.map((name) => ({ id: name })),
    isLoading: loading,
    isError: error,
  };
};

export default useGetExporterFiles;
